import { render, staticRenderFns } from "./examDetailsOwn.vue?vue&type=template&id=3a85216c&scoped=true"
import script from "./examDetailsOwn.vue?vue&type=script&lang=js"
export * from "./examDetailsOwn.vue?vue&type=script&lang=js"
import style0 from "./examDetailsOwn.vue?vue&type=style&index=0&id=3a85216c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85216c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a85216c')) {
      api.createRecord('3a85216c', component.options)
    } else {
      api.reload('3a85216c', component.options)
    }
    module.hot.accept("./examDetailsOwn.vue?vue&type=template&id=3a85216c&scoped=true", function () {
      api.rerender('3a85216c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/participateTestOwn/examDetailsOwn.vue"
export default component.exports